export const TOGGLE_MUST_LOGIN_SCREEN = 'TOGGLE_MUST_LOGIN_SCREEN'

export function displayMustLoginScreenReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_MUST_LOGIN_SCREEN:
            return action.payload
        default: return state
    }
}